import "vue-class-component/hooks";
import "swiper/css/swiper.css";
import "@/styles/global.scss";

// Primary packages
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import i18n from "./locales";

import LockApp from "./LockApp.vue";

// Third party packages
import VueAwesomeSwiper from "vue-awesome-swiper";
import VModal from "vue-js-modal";
import VueFormulate from "@braid/vue-formulate";
import Component from "vue-class-component";
import VueSocialSharing from "vue-social-sharing";
import device from "vue-device-detector";
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
});

Component.registerHooks(["metaInfo"]);

Vue.use(VueSocialSharing);
Vue.use(VueAwesomeSwiper);
Vue.use(VueFormulate);
Vue.use(VModal);
Vue.use(device);

if (process.env.NODE_ENV !== "development") {
  // Vue.use(
  //   VueGtag,
  //   {
  //     config: { id: "G-DHLWS3S52W" },
  //   },
  //   router
  // );
}

// Custom plugins
import {
  ConstantPlugin,
  UtilityPlugin,
  StoragePlugin,
  AuthPlugin,
  ApiPlugin,
} from "./plugins";
Vue.use(StoragePlugin);
Vue.use(UtilityPlugin);
Vue.use(ConstantPlugin);
Vue.use(ApiPlugin);
Vue.use(AuthPlugin);

// Register compoenents globally
import "@/components";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(process.env.NODE_ENV === "staging" ? LockApp : App),
}).$mount("#app");
